import AddToCart    from './basket/AddToCart'
import AddToCartJustButton    from './basket/AddToCartJustButton'
import HeaderBasket from './basket/HeaderBasket'
import HeaderBasketNew from './basket/HeaderBasketNew'
import FooterBasket from './basket/FooterBasket'
import HeaderSearch from './search/HeaderSearch'
import HeaderSearchNew from './search/HeaderSearchNew'
import MobileSearch from './search/MobileSearch'
import Spinner from './common/Spinner'
import ProductList from './product/ProductList'
import ProductImages from './product/ProductImages'
import ProductPreview from './product/ProductPreview'
import UserLogin from './user-popup/UserLogin'
import UserProfileMenu from './user-popup/UserProfileMenu'
import Checkout from './checkout/Checkout'
import FavoritesButton from './favorites-button/FavoritesButton'
import FilterActive from './filters/FilterActive'
import FilterList from './filters/FilterList'
import FilterSort from './filters/FilterSort'
import FilterLimit from './filters/FilterLimit'
import FavoritesUser from './favorites-button/FavoritesUser'
import FavoritesCategories from './favorites-categories/FavoritesCategories'
import FavoritesProducts from './favorites-products/FavoritesProducts'
import FavoritesProductEdit from './favorites-products/FavoritesProductEdit'
import Pagination from './filters/Pagination'
import NewsletterSignup from './newsletter/NewsletterSignup'
import NewsletterPopup from './newsletter/NewsletterPopup'
import NewsletterFooter from './newsletter/NewsletterFooter'
import Overview from './checkout/modules/Overview'
import HeaderMenu from './common/HeaderMenu'

export default {
  AddToCart,
  AddToCartJustButton,
  HeaderBasket,
  HeaderBasketNew,
  FooterBasket,
  HeaderSearch,
  MobileSearch,
  Spinner,
  ProductList,
  ProductImages,
  ProductPreview,
  UserLogin,
  UserProfileMenu,
  Checkout,
  Overview,
  FavoritesButton,
  FilterActive,
  FilterList,
  FilterSort,
  FilterLimit,
  FavoritesUser,
  FavoritesCategories,
  FavoritesProducts,
  FavoritesProductEdit,
  Pagination,
  NewsletterSignup,
  NewsletterPopup,
  NewsletterFooter,
  HeaderSearchNew,
  HeaderMenu
}
